import React, { useEffect, useRef, useState } from 'react';
import { TEMPLATES } from '../../../services/docsTemplates';
import './NewDocDialog.css';

/* Template picker for a new doc.
   Templates rather than doc types: every piece of production paperwork is the
   same technical thing (a titled table), so adding "one more crew document"
   later means adding a template here, not a new code path. */
function NewDocDialog({ parentTitle, onCancel, onCreate }) {
	const [selected, setSelected] = useState('blank');
	const panelRef = useRef(null);

	useEffect(() => {
		const onKey = (e) => {
			if (e.key === 'Escape') onCancel();
		};
		document.addEventListener('keydown', onKey);
		panelRef.current?.focus();
		return () => document.removeEventListener('keydown', onKey);
	}, [onCancel]);

	return (
		<div className='newdoc__backdrop' onClick={onCancel}>
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
			<div
				className='newdoc'
				role='dialog'
				aria-modal='true'
				aria-label='New doc'
				tabIndex={-1}
				ref={panelRef}
				onClick={(e) => e.stopPropagation()}>
				<h2 className='newdoc__title'>New doc</h2>
				<p className='newdoc__hint'>
					{parentTitle ? `Inside “${parentTitle}”.` : 'Start from a template.'}
				</p>

				<ul className='newdoc__list'>
					{TEMPLATES.map((t) => (
						<li key={t.key}>
							<button
								type='button'
								className={`newdoc__option ${selected === t.key ? 'is-selected' : ''}`}
								onClick={() => setSelected(t.key)}
								onDoubleClick={() => onCreate(t.key)}>
								<span className='newdoc__icon' aria-hidden='true'>
									<i className={`fa-solid ${t.icon}`}></i>
								</span>
								<span className='newdoc__text'>
									<span className='newdoc__label'>{t.label}</span>
									<span className='newdoc__sub'>{t.hint}</span>
								</span>
							</button>
						</li>
					))}
				</ul>

				<div className='newdoc__actions'>
					<button type='button' className='newdoc__cancel' onClick={onCancel}>
						Cancel
					</button>
					<button
						type='button'
						className='newdoc__confirm'
						onClick={() => onCreate(selected)}>
						Create
					</button>
				</div>
			</div>
		</div>
	);
}

export default NewDocDialog;
